<template>
  <div class="wj_wrap">
    <div class="order_main2 order_face" id="printContent" :style="{width:width+'px',height:height+'px'}">
      <div class="order_header">
        <img
          src="https://cn2ca-1259002481.cos.na-toronto.myqcloud.com/img/c076e719965343bcb1e09d8adcd8d9f4.png"
          class="code_img"
        />
      </div>
      <div class="order_box">
        <span class="l_label">分拨中心：</span
        ><span class="l_value">蒙特利尔</span>
        <span class="l_label l_label2">派送点：</span
        ><span class="l_value">Toronto</span>
      </div>
      <div class="order_detail">
        <div class="order_count">订单数量：2</div>
        <div data-v-075294c4="" class="product_list">
          <div data-v-075294c4="" class="l_item">
            <span data-v-075294c4="" class="l_item_val l_name"
              >测试测试测试测试测试测试测试测试测试</span
            >
            <span data-v-075294c4="" class="l_item_val">A00010</span>
            <span data-v-075294c4="" class="l_item_val">sf0425001</span>
          </div>
          <div data-v-075294c4="" class="l_item">
            <span data-v-075294c4="" class="l_item_val l_name"
              >测试商品042211</span
            >
            <span data-v-075294c4="" class="l_item_val">A00011</span>
            <span data-v-075294c4="" class="l_item_val">sf0425001</span>
          </div>
           <div data-v-075294c4="" class="l_item">
            <span data-v-075294c4="" class="l_item_val l_name"
              >测试商品042211</span
            >
            <span data-v-075294c4="" class="l_item_val">A00011</span>
            <span data-v-075294c4="" class="l_item_val">sf0425001</span>
          </div>
           <div data-v-075294c4="" class="l_item">
            <span data-v-075294c4="" class="l_item_val l_name">测试商品042211</span>
            <span data-v-075294c4="" class="l_item_val">A00011</span>
            <span data-v-075294c4="" class="l_item_val">sf0425001</span>
          </div>
          <div data-v-075294c4="" class="l_item">
            <span data-v-075294c4="" class="l_item_val l_name">测试商品042211</span>
            <span data-v-075294c4="" class="l_item_val">A00011</span>
            <span data-v-075294c4="" class="l_item_val">sf0425001</span>
          </div>
          <div data-v-075294c4="" class="box_footer2">
            <span data-v-075294c4="" class="box_time"
              ><span data-v-075294c4="" class="l_label">合箱时间：</span
              ><span data-v-075294c4="" class="l_value"
                >2021-04-25 07:50:54</span
              ></span
            >
            <span data-v-075294c4="" class="box_type"
              ><span data-v-075294c4="" class="l_label">运输方式：</span
              ><span data-v-075294c4="" class="l_value">海运</span></span
            >
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" v-print="printObj">打 印</el-button>
      <el-button>关 闭</el-button>
    </span>
  </div>
</template>

<script>
import * as unit from 'utils/unit'
export default {
    data(){
        return {
            width:"300",
            height:"260",
            printObj: {
                id: "printContent",
                popTitle: "",
                extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
           },
        }
    },
    created() {
      let that = this;
      that.width = unit.mmToPx(80);
      that.height = unit.mmToPx(60);
  },
}
</script>

<style lang="less" scoped>
.order_main2 {
  margin-left: 5px;
  .order_header {
    border-bottom: 1px solid #e1e1e1;
    width:100%;
    text-align: center;
    .code_img {
      height: 40px;
    }
  }
  .order_box {
    padding: 3px 0;
    border-bottom: 1px solid #e1e1e1;
    span {
      font-size: 10px;
      display: inline-block;
    }
    .l_label2{
        margin-left: 5px;
    }
    .l_value {
      font-size: 10px;
    }
  }
  .order_address {
    padding: 3px 0;
    border-bottom: 1px solid #e1e1e1;
    .p1 {
      font-size: 10px;
    }
  }
  .order_detail {
    margin-top: 5px;
    font-size: 12px;
    .order_count {
      font-size: 10px;
      font-weight: 600;
    }
  }
  .product_list {
     margin-top:2px;
    .l_item {
      padding: 1px 0;
      font-size: 10px;
      .l_item_val {
        margin-right: 6px;
        display: inline-block;
        vertical-align: middle;
        font-size: 10px;
      }
      .l_name {
        font-size: 10px;
        max-width: 90px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        vertical-align: middle;
      }
    }

    .box_footer2 {
      margin-top: 5px;
      position: relative;
      span {
        display: inline-block;
      }
      .box_time {
        span {
          font-size: 10px;
        }
      }
      .box_type {
        position: absolute;
        right: 5px;
        top: 0;
        span {
          font-size: 10px;
          font-weight: 600;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// face.vue?22b2aa29